export const VAELTHAR_IMPOSSIBLE_LIGHT_ID='vaelthar-impossible-light' as const;
export const VAELTHAR_IMPOSSIBLE_LIGHT_OWNER='vaelthar-astral-architect' as const;
export type VaeltharImpossibleLightMode='idle'|'move'|'cast-light'|'cast-heavy'|'ultimate'|'death';
export type VaeltharImpossibleLightState={time:number;mode:VaeltharImpossibleLightMode;energy:number;distortion:number;darkHalo:number;ringOpen:number;chroma:number;pulse:number};
export const VAELTHAR_IMPOSSIBLE_LIGHT_PROFILE={
 id:VAELTHAR_IMPOSSIBLE_LIGHT_ID,
 exclusiveTo:VAELTHAR_IMPOSSIBLE_LIGHT_OWNER,
 palette:{abyss:'#160020',violet:'#6416ff',magenta:'#e23dff',spectral:'#49efff',coldGold:'#efd59b'},
 pulse:[1,1.61803398875,2.41421356237,3.14159265359] as const,
 orbitCount:5,
 runeCount:11,
 maxPointIntensity:8.5,
 refractionStrength:.42,
 darkHaloStrength:1.35,
} as const;
export function canUseVaeltharImpossibleLight(characterId:string){return characterId===VAELTHAR_IMPOSSIBLE_LIGHT_OWNER}
export function assertVaeltharImpossibleLight(characterId:string){if(!canUseVaeltharImpossibleLight(characterId))throw new Error('Impossible Light is exclusive to Vaelthar')}
export function createVaeltharImpossibleLightState():VaeltharImpossibleLightState{return{time:0,mode:'idle',energy:.36,distortion:.06,darkHalo:.32,ringOpen:.17,chroma:0,pulse:0}}
export function stepVaeltharImpossibleLight(state:VaeltharImpossibleLightState,dt:number,mode:VaeltharImpossibleLightMode){
 const safeDt=Math.min(.05,Math.max(0,Number.isFinite(dt)?dt:0));
 state.time+=safeDt;state.mode=mode;
 const p=VAELTHAR_IMPOSSIBLE_LIGHT_PROFILE.pulse;
 state.pulse=Math.sin(state.time*p[0])*.34+Math.sin(state.time*p[1]+.7)*.24+Math.sin(state.time*p[2]+1.9)*.18+Math.sin(state.time*p[3]+2.7)*.1;
 state.chroma=.5+.5*Math.sin(state.time*.773+state.pulse*.8);
 const table:Record<VaeltharImpossibleLightMode,[number,number,number,number]>={
  idle:[.38,.055,.31,.17],move:[.5,.09,.40,.22],'cast-light':[.76,.16,.57,.36],
  'cast-heavy':[1.04,.27,.82,.53],ultimate:[1.48,.42,1.18,.82],death:[.08,.015,.06,.04],
 };
 const [energy,distortion,darkHalo,ringOpen]=table[mode];
 state.energy=Math.max(.02,energy+state.pulse*.08);
 state.distortion=distortion;state.darkHalo=darkHalo;state.ringOpen=ringOpen;
 return state;
}
export function vaeltharImpossibleMode(input:{dead?:boolean;moving?:boolean;attack?:'light'|'heavy'|'special'|null;ultimate?:boolean}):VaeltharImpossibleLightMode{
 if(input.dead)return'death';
 if(input.ultimate||input.attack==='special')return'ultimate';
 if(input.attack==='heavy')return'cast-heavy';
 if(input.attack==='light')return'cast-light';
 if(input.moving)return'move';
 return'idle';
}

export const VAELTHAR_IMPOSSIBLE_LIGHT_VERTEX_SHADER=`
varying vec3 vN;
varying vec3 vP;
void main(){
  vN=normalize(normalMatrix*normal);
  vP=position;
  gl_Position=projectionMatrix*modelViewMatrix*vec4(position,1.0);
}
`;
export const VAELTHAR_IMPOSSIBLE_LIGHT_FRAGMENT_SHADER=`
uniform float uTime;
uniform float uEnergy;
uniform float uChroma;
uniform float uHalo;
varying vec3 vN;
varying vec3 vP;
vec3 palette(float x){
  vec3 violet=vec3(0.39,0.055,1.0);
  vec3 magenta=vec3(0.91,0.08,1.0);
  vec3 cyan=vec3(0.12,0.92,1.0);
  vec3 gold=vec3(0.95,0.79,0.43);
  vec3 a=mix(violet,magenta,.5+.5*sin(x*1.618));
  vec3 b=mix(cyan,gold,.5+.5*sin(x*2.414+1.7));
  return mix(a,b,.18+.38*uChroma);
}
void main(){
  float facing=abs(dot(normalize(vN),vec3(0.,0.,1.)));
  float q=sin(uTime*1.0+vP.x*31.0)+
          .63*sin(uTime*1.618+vP.y*47.0+1.3)+
          .41*sin(uTime*2.414+vP.z*59.0+2.1)+
          .23*sin(uTime*3.1415926+dot(vP,vec3(17.,29.,43.)));
  float fold=.5+.5*sin(q*2.7+length(vP)*64.0-uTime*.37);
  float inversion=smoothstep(.16,.92,1.0-facing)*(0.3+uHalo*.22);
  vec3 spectral=palette(q+uTime*.11);
  vec3 dark=vec3(.006,.0,.018);
  vec3 color=mix(dark,spectral,clamp(.42+fold*.72-inversion*.44,0.,1.));
  color+=spectral*(.45+uEnergy*1.25)*pow(max(.0,1.-length(vP)*3.9),2.);
  float alpha=clamp(.42+fold*.35+uEnergy*.16,0.,1.);
  gl_FragColor=vec4(color,alpha);
}
`;
